import type { Product } from 'src/components/restructure/product/types/product'
import { Image } from 'src/components/ui/Image'

import SkuSelector from './SkuSelector'

interface BundleSkuSelectorsProps {
  currentProduct: Product
  suggestionProduct: Product
  currentProductSelectedSku: string | null | undefined
  suggestionProductSelectedSku: string | null | undefined
  setCurrentProductSelectedSku: React.Dispatch<
    React.SetStateAction<string | null>
  >
  setSuggestionProductSelectedSku: React.Dispatch<
    React.SetStateAction<string | null>
  >
}

const BundleSkuSelectors = ({
  currentProduct,
  suggestionProduct,
  currentProductSelectedSku,
  suggestionProductSelectedSku,
  setCurrentProductSelectedSku,
  setSuggestionProductSelectedSku,
}: BundleSkuSelectorsProps) => {
  const currentFirstAvailable = currentProduct.items.find(
    (item) => item.isAvailable
  )

  const suggestionFirstAvailable = suggestionProduct.items.find(
    (item) => item.isAvailable
  )

  const currentImage = currentFirstAvailable?.images[0]
  const suggestionImage = suggestionFirstAvailable?.images[0]

  const filterList = ['Cor']

  return (
    <div className="flex flex-col gap-[11px]">
      <div className="flex gap-3 w-full">
        <div className="max-w-[57px] w-full mix-blend-multiply bg-restructure-background-secondary">
          <Image
            src={currentImage?.imageUrl ?? ''}
            alt={currentImage?.imageText ?? currentProduct.productName}
            className="w-full h-full object-cover  mix-blend-multiply bg-restructure-background-secondary"
            width={57}
            height={64}
          />
        </div>
        <SkuSelector
          product={currentProduct}
          filters={filterList}
          onSelect={setCurrentProductSelectedSku}
          selectedSku={currentProductSelectedSku}
        />
      </div>

      <div className="flex gap-3 w-full">
        <div className="max-w-[57px] w-full mix-blend-multiply bg-restructure-background-secondary">
          <Image
            src={suggestionImage?.imageUrl ?? ''}
            alt={suggestionImage?.imageText ?? suggestionProduct.productName}
            className="w-full h-full object-cover max-w-[57px] mix-blend-multiply bg-restructure-background-secondary"
            width={57}
            height={64}
          />
        </div>

        <SkuSelector
          product={suggestionProduct}
          filters={filterList}
          onSelect={setSuggestionProductSelectedSku}
          selectedSku={suggestionProductSelectedSku}
        />
      </div>
    </div>
  )
}

export default BundleSkuSelectors
